import axios from 'axios'
import { publicationsHttp } from "../../common/http"

let defaultState = {
  publications: [],
  metadata: {},
  selectedTherapeuticAreas: [],
  selectedYears: [],
  currentPage: 1,
  limit: 10,
  publicationCount: 0,
  loading: false,
  pubCancelToken: null
}

export default function managePublications(state = defaultState, action) {
  switch(action.type) {
    case "GET_PUBLICATIONS":
      return { ...state, publications: action.payload.results, publicationCount: action.payload.filtered_count }
    case "GET_METADATA":
      return { ...state, metadata: action.payload }
    case "SET_SELECTED_THERAPEUTIC_AREAS":
        return { ...state, selectedTherapeuticAreas: action.payload }
    case "SET_SELECTED_YEARS":
      return { ...state, selectedYears: action.payload }
    case "SET_LIMIT":
      return { ...state, limit: action.payload }
    case "CHANGE_PAGE":
      return { ...state, currentPage: action.payload }
    case "SET_LOADING":
      return { ...state, loading: action.payload }
    case "SET_CANCEL_TOKEN":
      return { ...state, pubCancelToken: action.payload }
    default:
      return state
  }
}

export function getPublications(page=1, filters=null) {
  return ((dispatch, getState) => {
    const { pubCancelToken, limit } = getState().managePublications
    const offset = limit * (page - 1)
    
    if (pubCancelToken) {
      pubCancelToken.cancel("The request was canceled.")
    }
    const cancelToken = axios.CancelToken.source()
    dispatch({ type: "SET_CANCEL_TOKEN", payload: cancelToken })
    
    dispatch({ type: "SET_LOADING", payload: true })
    publicationsHttp.get("/", {
      params: { page, filters: filters && JSON.stringify(filters), limit, offset },
      cancelToken: cancelToken.token
    })
    .then(response => {
      dispatch({ type: "SET_LOADING", payload: false })
      dispatch({
        type: "GET_PUBLICATIONS",
        payload: response.data
      })
    })
    .catch(error => {
      if (axios.isCancel(error)) {
        return
      }
      dispatch({ type: "SET_LOADING", payload: false })
    })
  })
}

export function setSinglePublication(publication) {
  const result = {
    results: [].concat(publication),
    filtered_count: 1
  }
  return (dispatch => {
    dispatch({
      type: "GET_PUBLICATIONS",
      payload: result
    })
  })
}

export function getMetadata() {
  return (dispatch => {
    publicationsHttp.get("/metadata_for_website/")
    .then(response => {
      dispatch({
        type: "GET_METADATA",
        payload: response.data
      })
    })
    .catch(error => {
    })
  })
}

export function changePage(page=1) {
  return { type: "CHANGE_PAGE", payload: page }
}

export function setSelectedTherapeuticAreas(selection) {
  return { type: "SET_SELECTED_THERAPEUTIC_AREAS", payload: selection }
}

export function setSelectedYears(selection) {
  return { type: "SET_SELECTED_YEARS", payload: selection }
}

export function setLimit(selection) {
  return { type: "SET_LIMIT", payload: selection }
}